var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.path === '/login')?_c('div',{staticClass:"bgImg",attrs:{"id":"app"}},[_c('router-view'),_c('vue-snotify'),_c('vue-progress-bar')],1):_c('div',{staticClass:"container-fluid no-gutters",attrs:{"id":"app"}},[_c('router-view'),_c('vue-snotify'),_c('vue-progress-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }